import api from 'config/api';
import { login } from 'services/auth';
import { username } from './auth';

export const handleSignUp = async (e, values) => {
  e.preventDefault();
  try {
    const { data } = await api.post('/auth/login', values);
    login(data.accessToken);
    username(data.username);
    return true;
  } catch (err) {
    return false;
  }
};

export const refreshToken = async (e) => {
  e.preventDefault();
  try {
    const { data, status } = await api.post('/auth/refresh');
    login(data.accessToken);
    return status;
  } catch (err) {
    return false;
  }
};
